import { createContext } from "react";

/**
 * 面包屑尾部「动作插槽」。
 *
 * 背景（2026-10-13）：需求要求把「项目财务」页的收款报表（3 个图表）收进面包屑条尾部的一个
 * 带 icon 的按钮里，点击从按钮处展开/收起浮窗。
 *
 * 做法：Layout 在面包屑条右侧渲染一个空容器，并把它的 ref 放进本 context；
 * 页面用 `createPortal` 把按钮注入进去。
 *
 * 为什么用 portal 而不是让 Layout 直接渲染业务按钮：
 *   按钮仍活在**页面组件树**里，因此能拿到页面自己的状态（例如「项目财务」页当前选中的分公司），
 *   从而保留「点分公司 chip → 报表图表跟着筛」的既有联动；同时 Layout 保持通用，不必认识具体业务。
 */
export const BreadcrumbSlotContext = createContext(null);
